(function () {
  function init() {
    var form = document.getElementById("qr-contact-form");
    if (!form || form.dataset.qrInit) return;
    form.dataset.qrInit = "true";

    var full = form.querySelector("[data-qr-full-name]");
    var first = form.querySelector("[data-qr-first-name]");
    var last = form.querySelector("[data-qr-last-name]");

    form.addEventListener("submit", function () {
      if (full && first && last) {
        full.value = (first.value + " " + last.value).trim();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
